var chunkToChildrenMap = {
	"4077": [
		73758
	],
	"6123": [
		73758
	],
	"42671": [
		85141
	],
	"56763": [
		75232,
		75648
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));